import { getBonus } from 'model/bonus';

export default store => ({
	path: 'bonus',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Bonus',
			),
		onEnter: () => {
			store.dispatch(getBonus());
		},
	},
});
